/**
 * EasyWorkChat - REST API Wrapper
 */
import api from './api';

export const chatService = {
  listRooms: () => api.get('/chat/rooms').then(r => r.data.rooms),
  getRoom: (roomId) => api.get(`/chat/rooms/${roomId}`).then(r => r.data.room),
  createRoom: (payload) => api.post('/chat/rooms', payload).then(r => r.data.room),
  updateRoom: (roomId, patch) => api.patch(`/chat/rooms/${roomId}`, patch).then(r => r.data.room),
  leaveRoom: (roomId) => api.post(`/chat/rooms/${roomId}/leave`).then(r => r.data),
  listMessages: (roomId, { before, limit = 50 } = {}) => {
    const params = { limit };
    if (before) params.before = before;
    return api.get(`/chat/rooms/${roomId}/messages`, { params }).then(r => r.data.messages);
  },
  sendMessage: (roomId, content, opts = {}) =>
    api.post(`/chat/rooms/${roomId}/messages`, {
      content,
      message_type: opts.message_type || 'text',
      reply_to_message_id: opts.reply_to_message_id || null,
      mentions: opts.mentions || [],
      project_ids: opts.project_ids || [],
    }).then(r => r.data.message),
  // Projekt-Bezug: @-Suche und projektbezogene Chats (Projekt-Tab „Chat“)
  projectSearch: (q) => api.get('/chat/project-search', { params: { q, limit: 6 } }).then(r => r.data.projects),
  projectChats: (projectId) => api.get(`/chat/projects/${projectId}`).then(r => r.data),
  uploadAttachment: (roomId, file, opts = {}) => {
    const fd = new FormData();
    fd.append('file', file);
    if (opts.caption) fd.append('caption', opts.caption);
    if (opts.reply_to_message_id) fd.append('reply_to_message_id', opts.reply_to_message_id);
    return api.post(`/chat/rooms/${roomId}/upload`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: opts.onProgress,
    }).then(r => r.data.message);
  },
  markRead: (roomId) => api.post(`/chat/rooms/${roomId}/read`).then(r => r.data),
  unreadCount: () => api.get('/chat/unread-count').then(r => r.data.unread_count),
  tenantMembers: () => api.get('/chat/tenant-members').then(r => r.data.members),
  toggleReaction: (messageId, emoji) =>
    api.post(`/chat/messages/${messageId}/react`, { emoji }).then(r => r.data),
  editMessage: (messageId, content) =>
    api.patch(`/chat/messages/${messageId}`, { content }).then(r => r.data.message),
  deleteMessage: (messageId, forAll = false) =>
    api.delete(`/chat/messages/${messageId}`, { params: { for_all: forAll } }).then(r => r.data),
  toggleStar: (messageId) =>
    api.post(`/chat/messages/${messageId}/star`).then(r => r.data),
  listStarred: () => api.get('/chat/starred').then(r => r.data.messages),
  listMedia: (roomId, kind = 'all') =>
    api.get(`/chat/rooms/${roomId}/media`, { params: { kind } }).then(r => r.data),
  search: (q, roomId) => {
    const params = { q };
    if (roomId) params.room_id = roomId;
    return api.get('/chat/search', { params }).then(r => r.data);
  },
  exportData: () => api.get('/chat/export').then(r => r.data),
  getMute: (roomId) => api.get(`/chat/rooms/${roomId}/mute`).then(r => r.data),
  mute: (roomId, minutes) =>
    api.post(`/chat/rooms/${roomId}/mute`, minutes != null ? { minutes } : {}).then(r => r.data),
  unmute: (roomId) => api.delete(`/chat/rooms/${roomId}/mute`).then(r => r.data),
  // Chat löschen: für mich (ausblenden + Verlauf leeren) oder für alle (nur Ersteller/Admin)
  deleteRoom: (roomId, forAll = false) =>
    api.delete(`/chat/rooms/${roomId}`, { params: { for_all: forAll } }).then(r => r.data),
  // Persönliche Chat-Ordner
  listFolders: () => api.get('/chat/folders').then(r => r.data.folders),
  createFolder: (name) => api.post('/chat/folders', { name }).then(r => r.data.folder),
  updateFolder: (folderId, patch) => api.put(`/chat/folders/${folderId}`, patch).then(r => r.data.folder),
  deleteFolder: (folderId) => api.delete(`/chat/folders/${folderId}`).then(r => r.data),
  moveRoomToFolder: (roomId, folderId) =>
    api.put(`/chat/rooms/${roomId}/folder`, { folder_id: folderId || null }).then(r => r.data),
};

export default chatService;
